import React from 'react'
import {Svg, CommonSvgProps, commonPropTypes, commonDefaultProps} from '@modifi/ui'

type PeopleIconProps = CommonSvgProps

const PeopleIcon: React.FC<PeopleIconProps> = React.forwardRef<SVGSVGElement, PeopleIconProps>(
  (props, ref) => (
    <Svg viewBox="0 0 50 38" {...props} ref={ref} color="none">
      <path
        d="M2 36C2.37349 32.4314 6.93012 23 17.6867 23C28.4434 23 33 32.9412 33 36"
        stroke="#51565C"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <circle cx="17" cy="9" r="7.5" fill="#7BB835" stroke="#51565C" strokeWidth="3" />
      <path
        d="M47.9722 35C47.9722 32.536 44.3016 24.5278 35.6365 24.5278C33.2577 24.5185 30 25.5001 28.5 27.5001"
        stroke="#51565C"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <circle
        cx="35.0833"
        cy="13.25"
        r="5.75"
        fill="#53A2D9"
        stroke="#51565C"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </Svg>
  )
)

PeopleIcon.propTypes = commonPropTypes
PeopleIcon.defaultProps = commonDefaultProps

export default PeopleIcon
